import { render, staticRenderFns } from "./MessageTypeConditionSetupView.vue?vue&type=template&id=253d51e3&scoped=true&"
import script from "./MessageTypeConditionSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessageTypeConditionSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d51e3",
  null
  
)

export default component.exports